module.exports = __webpack_public_path__ + "img/logs.effac1d9.svg";